import * as React from 'react';
import _, { filter, values } from 'lodash';
import { Paper, makeStyles, Grid, TextField, Button } from '@material-ui/core';
import { SelectWithLabel } from '../../utils/selectWithLabel';
import { useDispatch, useSelector } from 'react-redux';
import { sendEmail, setEmailStatus } from '../../store/departures';
import { getTemplateChoices } from './utils/templateChoices';
import { MessageStatusDisplay } from './utils/messageStatusDisplay';
import { SelectWithLabelAndCheckbox } from '../../utils/selectWithLabelAndCheckbox';

let screenWidth = window.innerWidth

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  paper: {
    position: 'absolute',
    width: screenWidth <= 450 ? '90%' : '50%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    // padding: theme.spacing(2, 4, 3),
  },
  sendingPaper: {
    position: 'absolute',
    paddingTop: '6px',
    paddingBottom: '8px',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    marginTop: '12%',
    padding: '2px 4px 2px 4px'
  }
}));

// NOTE // handles inputs for the email(s)
const EmailInputGroup = (props) => {
  let template = props.template
  let recipients = props.recipients
  let customEmail = props.customEmail
  let templateChoices = props.templateChoices
  let formattedPaxChoices = props.formattedPaxChoices
  let handleTemplate = props.handleTemplate
  let handleRecipients = props.handleRecipients
  let handleCustomEmail = props.handleCustomEmail



  if (!recipients.includes('Custom')) {
    return (
      <Grid container item xs={12} justify="center" style={{paddingTop: '5px', paddingBottom: '5px', borderBottom: '2px solid rgba(201, 195, 195, 1)'}}>
        <Grid container item lg={4} xs={12} justify="center">
          <SelectWithLabel defaultVal={template} handleChange={(e) => {handleTemplate(e)}} inputLabel={'Template'} items={templateChoices} />
        </Grid>
        <Grid item xs={2}></Grid>
        <Grid container item lg={4} xs={12} justify="center">
          <SelectWithLabelAndCheckbox multiple={true} defaultVal={recipients} handleChange={(e) => {handleRecipients(e)}} inputLabel={'Recipients'} items={formattedPaxChoices} />
        </Grid>
      </Grid>
    )
  }
  else {
    return (
      <Grid container item xs={12} justify="center" style={{paddingTop: '5px', paddingBottom: '5px', borderBottom: '2px solid rgba(201, 195, 195, 1)'}}>
        <Grid container item lg={4} xs={12} justify="center">
          <SelectWithLabel defaultVal={template} handleChange={(e) => {handleTemplate(e)}} inputLabel={'Template'} items={templateChoices} />
        </Grid>
        <Grid container item lg={4} xs={12} justify="center">
          <SelectWithLabel multiple={false} defaultVal={recipients} handleChange={(e) => {handleRecipients(e)}} inputLabel={'Recipients'} items={formattedPaxChoices} />
        </Grid>
        <Grid container item lg={4} xs={12} justify="center">
          <TextField label="Custom Email" value={customEmail} onChange={(e) => {handleCustomEmail(e.target.value)}} />
        </Grid>
      </Grid>
    )
  }
}





export const EmailModal = (props) => {
  const passengers = props.paxInfo.passengers ? props.paxInfo.passengers : []
  const flightNum = `AN${props.paxInfo.flightStatus.flightNumber}`
  // const passengers = tempEmailData
  const classes = useStyles()
  const emailStatus = useSelector(state => state.entities.departures.emailStatus)
  // NOTE // these all live and die in the modal, and aren't affected by api calls, so I don't think we should use flux here
  const [customEmail, setCustomEmail] = React.useState('')
  // NOTE // defaults are set for the an-general template
  const [recipients, setRecipients] = React.useState([])
  const [template, setTemplate] = React.useState('custom message')
  const [templateId, setTemplateId] = React.useState('an-general')
  const [templateKeys, setKeys] = React.useState(['message'])
  const [substitutionData, setSubData] = React.useState({message: ''})
  const dispatch = useDispatch()

  let templateChoices = getTemplateChoices('AN', 'email', ' ')

  // NOTE // formatting choices for SelectWithLabel and for the api call
  let passengerChoices = []
  let formattedPaxChoices = []
  if (passengers && passengers.length) {
   
    // NOTE // information (emails) being sent to api
    passengerChoices = passengers.map(p => {
      return {value: p.reservation.bookingInformation.contactInformation.email || '', label: `${p.reservation.bookingInformation.contactInformation.email} (${p.reservation.locator})` || ''}
    }).filter(choice => choice.value != '')
    formattedPaxChoices = [{label: 'All', value: 'All'}, {label: 'Custom', value: 'Custom'}].concat(_.uniqBy(passengerChoices, 'value'))
  }

  const handleTemplate = (e) => {
    // NOTE // splits the template value to get the keys
    let keyArray = e.target.value.split(" ")
    // NOTE // sets the template value for the select input
    setTemplate(e.target.value)
    // NOTE // sets the templateId (the first value in the array)
    setTemplateId(keyArray[0])
    // NOTE // removes the templateId and uses the rest as keys for substitution data used in the template
    keyArray.splice(0, 1)
    setKeys(keyArray)
  }

  const handleRecipients = (e) => {
    // setRecipients(e.target.value)
    const {
        target: { value },
      } = e;
      if(value.includes('All')){
        setRecipients([])
        setRecipients(formattedPaxChoices.filter((e)=> e.value !== 'Custom').map((e)=>e.value))
      }else{
        setRecipients(
          typeof value === 'string' ? value.split(',') : value,
        );
      }     
  }

  // const handleSend = () => {
  //   let emails
  //   emails = recipients == 'All' ? passengerChoices.map(p => p.value) : [recipients]
  //   if (recipients == 'All') {
  //     emails = passengerChoices.map(p => p.value)
  //   }
  //   else if (recipients == 'Custom') {
  //     emails = [customEmail]
  //   }
  //   else {
  //     emails = recipients
  //   }


  //   if (emails && emails.length) {
  //     // NOTE // set a status for each email being sent
  //     dispatch(setEmailStatus(emails))

  //     // NOTE // send the emails
  //     let subData = substitutionData
  //     dispatch(sendEmail(emails, flightNum,templateId, subData))
  //   }
  // }

   const handleSend = () => {
    let emails
    emails = recipients == 'All' ? passengerChoices.map(p => p.value) : [recipients]
    if (recipients == 'All') {
      emails = passengerChoices.map(p => p.value)
    }
    else if (recipients == 'Custom') {
      emails = [customEmail]
    }
    else {
      emails = recipients
    }

    // console.log(`emails`, emails)
    // if (emails && emails.length) {
    //   // NOTE // set a status for each email being sent
    //   dispatch(setEmailStatus(emails))

    //   // NOTE // send the emails
    //   let subData = substitutionData
    //   dispatch(sendEmail(emails, flightNum,templateId, subData))
    // }

    // Remove "All" if present
    const filteredEmails = emails.filter(email => email !== "All");

    if (filteredEmails && filteredEmails.length) {
      // Set a status for each email being sent
      dispatch(setEmailStatus(filteredEmails));

      // Send the emails
      let subData = substitutionData;
      dispatch(sendEmail(filteredEmails, flightNum, templateId, subData));
    }
  }

  const handleSubData = (event, key) => {
    let subDataCopy = _.cloneDeep(substitutionData)
    subDataCopy[key] = event.target.value
    setSubData(subDataCopy)
  }

  // NOTE // checks if user has input data for each property
  const checkSubstitutionData = () => {
    let hasData = 0
    for (let i = 0; i < templateKeys.length; i++) {
      const key = templateKeys[i];
      if (substitutionData[key]) {
        hasData += 1
      }
    }
    return hasData == templateKeys.length
  }

  return (
    <Grid container justify="center" alignContent="center" style={{marginTop: '10%'}}>
      {/* NOTE // emailStatus should be null except after sending emails and before closing the modal (closing the modal sets it back to null) */}
      { (emailStatus && emailStatus !== null) ?
          // SECTION email-status
          <Paper className={classes.sendingPaper}>
            <Grid container justify="center" alignContent="center" style={{height: '100%'}}>
              <Grid container item xs={12} justify="center" style={{marginBottom: '8px'}}>
                <MessageStatusDisplay status={emailStatus} type={'email'} />
              </Grid>
              <Grid container item xs={12} justify="center">
                <Button variant="contained" size="small" onClick={() => {props.closeModal(false)}} style={{backgroundColor: '#eb494e'}}>Close</Button>
              </Grid>
            </Grid>
          </Paper> :
          // !SECTION
          // SECTION email-form
          <Paper className={classes.paper}>
            <Grid container item xs={12} justify="center" style={{fontSize: '60px', width: '100%', height: '20%', borderBottom: '2px solid rgba(201, 195, 195, 1)', backgroundColor: 'rgb(63, 81, 181, 1)'}}>
              <h5 style={{margin: '0px', paddingTop: '12px'}}>Email Pax</h5>
            </Grid>
            {/* NOTE // handles template, recipients, and customEmail */}
            <EmailInputGroup template={template} recipients={recipients} customEmail={customEmail} handleTemplate={handleTemplate} handleRecipients={handleRecipients} handleCustomEmail={setCustomEmail} templateChoices={templateChoices} formattedPaxChoices={formattedPaxChoices} />
            {
              templateKeys.length == 1 ?
              <Grid container item xs={12} style={{paddingTop: '3em', paddingLeft: '5em', paddingRight: '5em', height: '40%' }}>
                <TextField
                  id="filled-multiline-static"
                  label="Message"
                  multiline
                  rows={8}
                  value={substitutionData[templateKeys[0]]}
                  onChange={(e) => {handleSubData(e, templateKeys[0])}}
                  variant="filled"
                  style={{width: '100%'}}
                />
              </Grid> :
              <Grid container style={{ paddingTop: '1em', paddingLeft: '5em', paddingRight: '5em', height: '40%' }}>
              {
                templateKeys.map((key, index) => (
                  <Grid container justify="center" item xs={ templateKeys.length >= 4 ? 6 : 12 }>
                    <TextField key={key} index={index} value={substitutionData[key]} onChange={(e) => {handleSubData(e, key)}} variant="filled" style={{ width: '70%', marginTop: '5px' }} label={key} />
                  </Grid>
                ))
              } 
              </Grid>
            }
            <Grid container style={{marginBottom: '5%', marginTop: '5%'}}>
              <Grid style={{textAlign: 'center'}} item lg={7} xs={12}>
                <p style={{color: 'red'}}>
                  { (!passengers || !checkSubstitutionData() ? 'You need recipients and template-data to send' : '') }
                </p>
              </Grid>
              <Grid item xs={3} lg={1}></Grid>
              <Grid item xs={3} lg={1} style={{marginRight: '5%'}}>
                {
                  passengers && checkSubstitutionData() ? <Button onClick={() => {handleSend()}} variant="contained" style={{backgroundColor: '#03fc66'}}>Send</Button> :
                  <Button variant="contained" disabled style={{backgroundColor: '#03fc66'}}>Send</Button>
                }
              </Grid>
              <Grid item xs={3} lg={1}>
                <Button variant="contained" onClick={() => {props.closeModal(false)}} style={{backgroundColor: '#eb494e'}}>Close</Button>
              </Grid>
            </Grid>
          </Paper>
          // !SECTION
      }
    </Grid>
  )
}